import type { CSSProperties } from 'react';
import { COLORS, FONT_STACK } from '@/lib/brand';
import { isIOS } from '@/lib/isIOS';

// iOS-only reassurance, shown at EVERY photo-upload entry point. Large iCloud
// albums make the native picker spin for up to a minute ("votre iPhone exporte
// les images") and some users close the tab thinking it froze. This is a calm,
// on-brand info note (warm cream + sage, brand tokens, soft cloud icon) — never
// an alarming banner. Hidden on Android + desktop via isIOS().
//
// `active` = an import is actually in progress → deepen it slightly (still gentle).
export function IosUploadNote({
  className = '',
  active = false,
  style,
}: {
  className?: string;
  active?: boolean;
  style?: CSSProperties;
}) {
  if (!isIOS()) return null;
  return (
    <div
      role="note"
      className={className}
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        padding: '9px 12px',
        borderRadius: 12,
        background: active ? COLORS.accentSoft : COLORS.bgElevated,
        border: `1px solid ${active ? COLORS.borderDefault : COLORS.borderSubtle}`,
        transition: 'background 200ms ease, border-color 200ms ease',
        ...style,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
        style={{ flexShrink: 0, marginTop: 1 }}
      >
        {/* soft cloud — evokes iCloud without alarm */}
        <path
          d="M7 18.5h10a4 4 0 0 0 .45-7.97A5.5 5.5 0 0 0 6.5 9.4 3.75 3.75 0 0 0 7 18.5Z"
          stroke={COLORS.success}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
      <span style={{ fontSize: 13, lineHeight: 1.5, color: COLORS.textSecondary, fontFamily: FONT_STACK.body }}>
        Import depuis iCloud — les grands albums peuvent prendre jusqu'à une minute.{' '}
        <span style={{ fontWeight: 600, color: COLORS.textPrimary }}>Ne fermez pas la galerie photo après avoir cliqué.</span>
      </span>
    </div>
  );
}
